/**
 * Trạng thái hộ sơ KBNN
 */
export default {
  Waiting: 'Chờ KBNN xử lý',
  Completed: 'Đã hoàn thành giao nhận',
  Rejected: 'Từ chối',
};
